const appConfig = {
    apiPrefix: 'https://visitor.5techg.com/api/',
    apiBaseURL: 'https://visitor.5techg.com',
    //apiPrefix: 'https://ra-masale-new-visitor-server.onrender.com/api/',
    // apiBaseURL: 'https://ra-masale-new-visitor-server.onrender.com',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: true,
}

export default appConfig
